<!-- 显示屏详情 -->
<template>
  <displayDetailWin :shiquArray='shiquArray' :detailObj='detailObj' :detailNetObj='detailNetObj'
                    :deviceProperty='deviceProperty' v-bind='$attrs' :deviceType='deviceType'></displayDetailWin>
</template>

<script>
import displayDetailWin from './component/displayDetailWin.vue'
import { contentList, displayGetDisplayDetailInfo } from '@/api/modules/display.js'

export default {
  data () {
    return {
      detailNetObj: {},
      deviceType: {},
      deviceProperty: {},
      detailObj: {},
      shiquArray: []
    }
  },
  components: {
    displayDetailWin
  },
  methods: {
    detailFn (id) {
      displayGetDisplayDetailInfo(id).then(({ result }) => {
        console.log(result.display)
        // 处理url 因为显示屏是一对多 所以需要特殊处理
        let url = []
        result.display.carrierRspList.forEach(item => {
          url.push(item.fullPath)
        })

        url = [...new Set(url)]
        // if (!url.length)
        //     url = [scopeName]

        const {
          appConfig,
          display,
          netConfig
        } = result
        this.detailObj = Object.assign({}, display, { url })
        this.detailNetObj = netConfig || {}
        this.deviceType = result.deviceType
        this.deviceProperty = result.deviceProperty || {}
      })
    },
    /** 时区 */
    contentListFn () {
      if (this.shiquArray.length > 0) return
      contentList({
        code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE',
        type: 0
      }).then(({ result }) => {
        this.shiquArray = result
      })
    }
  },
  mounted () {
    this.contentListFn()
    if (this.$route.query && this.$route.query.id) {
      const { id } = this.$route.query
      this.detailFn(id)
    }
  }
}
</script>

<style>
</style>
